export default __webpack_public_path__ + "146aee7c54b0858663ef94dd511a1a57.pdf";